<template>
    <b-card-body>
        <b-card bg-variant="light">

            <b-form-row @keyup.enter="load">
                <b-col lg="4" sm="4" class="text-left">
                    <lg-form-input v-model="form.descricao" label="Número/Descrição:" description=" " />
                </b-col>

                <b-col lg="4" sm="4" class="text-left">
                    <lg-finder-page-tipo-medida v-model="form.tipoMedida" :prefix="prefix + title + ' > '"
                        id="finderTipoMedidaTabProduto" @input="selectTipoMedida"></lg-finder-page-tipo-medida>
                </b-col>

                <b-col lg="3" sm="3" class="text-left">
                    <lg-form-const-select label="Tipo Produto:" @change="load" v-model="form.tipoProduto"
                        :options="form.optionsFilterGrupoProduto" />
                </b-col>

                <b-col lg="3" sm="3" class="text-left">
                    <lg-form-const-select label="Disponibilidade:" @change="load" v-model="form.disponibilidade"
                        :options="form.disponibilidadeList" />
                </b-col>


                <b-col lg="3" sm="3" class="text-left">
                    <lg-form-const-select label="Visibilidade:" @change="load" v-model="form.visiblidade"
                        :options="form.visiblidadeList" />
                </b-col>



                <b-col cols="2" class="text-right mt-2">

                    <b-button id="limpar-unidade-almoxarifado" class="my-2" size="sm" style="height: 20px" pill
                        variant="primary" @click="limpar">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="eraser" />
                        </div>
                        <b-tooltip target="limpar-unidade-almoxarifado" title="Limpar"></b-tooltip>
                    </b-button>
                    <b-button id="btnPesquisar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                        @click="load">
                        <b-tooltip :target="'btnPesquisar'" title="Localizar"></b-tooltip>
                        <div class="btn-size-alinhamento">
                            <b-icon icon="search" />
                        </div>
                    </b-button>
                    <b-button id="novo-vinculo-almoxarifado-produto" class="ml-3 mr-2 my-2" style="height: 20px"
                        @click="mostrarModalProduto" size="sm" pill variant="secondary">
                        <div class="btn-size-alinhamento">
                            <b-icon scale="1" icon="plus" />
                        </div>
                        <b-tooltip target="novo-vinculo-almoxarifado-produto" title="Adicionar novo..."></b-tooltip>
                    </b-button>
                </b-col>
            </b-form-row>
        </b-card>

        <b-card bg-variant="light">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
                :hover="true" show-empty>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>
                        Nenhum Registro encontrado
                    </p>
                </template>
                <template v-slot:cell(ponto)="row">

                    <div style="width: 27px">
                        <b-button v-b-tooltip.hover.top="'Visualizar Ponto Ressuprimento'" :id="'visualizar-ponto-tooltip' + row.index"
                            @click="showModalRessuprimentoFunction(row.item)" variant="primary" size="sm"
                            class="align-items-center justify-content-center">
                            <b-icon icon="file-text" />
                        </b-button>
                    </div>
                </template>


                <template v-slot:cell(bloquear)="row">

                    <div style="width: 27px">

                        <b-button v-b-tooltip.hover.top="row.item.bloqueado == 1 ? 'Desbloquear' : 'Bloquear'" :id="'visualizar-bloquear-tooltip' + row.index" @click="alteraSituacao(row.item)"
                            variant="primary" size="sm" class="align-items-center justify-content-center">
                            <b-icon :icon="row.item.bloqueado == 1 ? 'unlock-fill' : 'lock-fill'" />
                        </b-button>
                    </div>
                </template>

                <template v-slot:cell(visibilidade)="row">

                    <div style="width: 27px">
                        <b-button :id="'visualizar-visibilidade-tooltip' + row.index"
                            @click="alteraVisibilidade(row.item)" variant="primary" size="sm"
                            class="align-items-center justify-content-center" v-b-tooltip.hover.top="row.item.invisivel == 0 ? 'Tornar invisível' : 'Tornar visível'" >

                            <b-icon :icon="row.item.invisivel == 0 ? 'eye-fill' : 'eye-slash-fill'" />
                        </b-button>
                    </div>
                </template>

                <template v-slot:cell(vinculo)="row">
                    <b-button v-b-tooltip.hover.top="'Vincular Unidades Administrativas...'" :id="row.index + 'vinculo-unidade-almoxarifado'" class="my-2" size="sm" pill
                        variant="primary" @click="showModalVinculoUnidadeAdministrativa(row.item)">
                        <b-icon icon="house-fill" />
                    </b-button>
                </template>

                <template v-slot:cell(excluir)="row">
                    <b-button v-b-tooltip.hover.top="'Remover...'" :id="row.index + 'excluir-unidade-almoxarifado'" class="my-2" size="sm" pill
                        variant="primary" @click="remove(row.item)">
                        <b-icon icon="trash-fill" />
                    </b-button>
                </template>


            </b-table>

            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                        {{
                            totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <ModalPontoRessuprimentoProduto v-if="showModalRessuprimento" :produto="produto"
            @close="closeModalPontoRessuprimento" />

        <ModalVinculoUnidadeAdministrativa :prefix="prefix" v-if="mostrarModalVinculoUnidadeAdministrativa"
            :almoxarifado="almoxarifadoSelecionado" @close="fecharModalVinculoUnidadeAdministrativa" />

        <ModalConsultaProdutoCadastroEssencial v-if='showModalProduto' id="finderProdutoRegistroFormTabProduto"
            @onselect="handleSelectProduto" :prefix="prefix" />

    </b-card-body>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LgFinderPageTipoMedida from "@/components/Finders/LgFinderPageTipoMedida.vue"
import ModalPontoRessuprimentoProduto from "@/components/Modal/ModalPontoRessuprimentoProduto.vue"
import ModalVinculoUnidadeAdministrativa from "./ModalVinculoUnidadeAdministrativa.vue";
import ModalConsultaProdutoCadastroEssencial from "@/core/components/Modals/ModalConsultaProdutoCadastroEssencial.vue"

export default {
    components: {
        ModalConsultaProdutoCadastroEssencial,
        ModalPontoRessuprimentoProduto,
        LgFinderPageTipoMedida,
        LgFormConstSelect,
        LgFormInput,
        ModalVinculoUnidadeAdministrativa
    },
    props: {
        almoxarifado: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Configuração Almoxarifado",
        },
        currentSubgrupo: Object,
    },
    data() {
        return {
            showModalProduto: false,
            almoxarifadoSelecionado: null,
            mostrarModalVinculoUnidadeAdministrativa: false,

            showModalRessuprimento: false,
            produto: {},
            page: 1,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100],

            form: {
                optionsFilterGrupoProduto: [
                    { key: "filtertipoProduto", text: "Todos", value: null },
                    { key: "filtertipoProduto", text: "Material de Consumo", value: 4 },
                    { key: "filtertipoProduto", text: "Material Permanente", value: 5 },
                    { key: "filtertipoProduto", text: "Serviço", value: 6 },
                ],
                disponibilidadeList: [
                    { key: "filterDisponibilidade", text: "Todos", value: null },
                    { key: "filterDisponibilidade", text: "Disponível", value: 0 },
                    { key: "filterDisponibilidade", text: "Bloqueado", value: 1 },

                ],
                visiblidadeList: [
                    { key: "filtroVisibilidade", text: "Todos", value: null },
                    { key: "filtroVisibilidade", text: "Visível", value: 1 },
                    { key: "filtroVisibilidade", text: "Invisível", value: 0 },

                ],

                visiblidade: null,
                disponibilidade: 0,
                tipoProduto: null,
                descricao: "",
                tipoMedida: {},
            },

        }
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormResourceMixin],

    async beforeMount() {
        this.$service = new ResourceService(`api/almoxarifados/${this.almoxarifado.id}/produtos`)
        this.load();
    },
    watch: {
        page() {
            this.load()
        },
    },
    methods: {
        async handleSelectProduto(item) {
            this.showModalProduto = false;

            if (!item)
                return;
            this.busy = true;
            try {
                await this.$saveResource({ idAlmoxarifado: this.almoxarifado.id, bloqueado: 0, invisivel: 0, inventariando: 0, produto: { id: item.id } }, "", false, {}, false, true);

            }
            catch (error) {
                this.busy = false;
                this.showModalProduto = false;

                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
            this.load();

            this.showModalProduto = false;
        },
        mostrarModalProduto() {
            this.showModalProduto = true;
        },
        fecharModalVinculoUnidadeAdministrativa() {
            this.almoxarifadoSelecionado = null;
            this.mostrarModalVinculoUnidadeAdministrativa = false;
        },
        showModalVinculoUnidadeAdministrativa(item) {
            this.almoxarifadoSelecionado = item;
            this.mostrarModalVinculoUnidadeAdministrativa = true;
        },

        async confirmarAlteracaoVisibilidade(item) {
            try {
                await this.$service.put(`${item.id}/altera-visibilidade`);
                this.$notify({
                    type: "success",
                    message: `Visibilidade alterada com sucesso!`,
                });
                this.load();
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });

            }
        },

        async alteraVisibilidade(item) {
            let response = await this.$confirm(
                "Deseja tornar " + (item.visiblidade === 0 ? "visível" : "invisível") + " o produto?"
            )
            if (response == true) {
                this.confirmarAlteracaoVisibilidade(item)
            }
        },


        async confirmarAlteracaoSituacao(item) {
            try {
                await this.$service.put(`${item.id}/altera-bloqueio`);
                this.$notify({
                    type: "success",
                    message: `Registro ${item.bloqueado == 0 ? "desbloqueado" : "bloqueado"
                        } com sucesso!`,
                });
                this.load();
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });

            }
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.bloqueado === 1 ? "desbloquear" : "bloquear") + " o Produto?"
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            }
        },
        closeModalPontoRessuprimento() {
            this.produto = {};
            this.showModalRessuprimento = false;

        },
        showModalRessuprimentoFunction(produto) {
            this.produto = produto;
            this.showModalRessuprimento = true;
        },
        selectTipoMedida(tipoMedida) {
            this.form.tipoMedida = tipoMedida;
            this.load();
        },
        limpar() {
            this.form.descricao = "";
            this.form.tipoMedida = {};
            this.form.tipoProduto = null;
            this.form.visiblidade = null;
            this.form.disponibilidade = 0;

            this.load();
        },
        async remove(item) {
            await this.$removeResource(item)
        },

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        async load() {

            var filtro = {};



            if (this.form.descricao && this.form.descricao != "")
                filtro.descricao = this.form.descricao;

            if (this.form.tipoMedida && this.form.tipoMedida.id)
                filtro.tipoMedida = this.form.tipoMedida.id;

            if (this.form.tipoProduto != null)
                filtro.tipoProduto = this.form.tipoProduto;

            if (this.form.visiblidade != null)
                filtro.visiblidade = this.form.visiblidade;

            if (this.form.disponibilidade != null)
                filtro.disponibilidade = this.form.disponibilidade;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,

            });
            this.busy = false;

        },

    },
    computed: {
        tableFields() {
            return [
                {
                    key: "numero",
                    label: "Número",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "descricaoProduto",
                    label: "Descrição",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "ponto",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },

                {
                    key: "bloquear",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "visibilidade",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },

                {
                    key: "vinculo",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },


                {
                    key: "excluir",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },

    }

}
</script>